export default __webpack_public_path__ + "static/gilroy-light-53cea7ec8ce5bdf6149ed82259c2aeb2.eot";